<div class="ndvi-dialog">
  <div mat-dialog-content class="dialog-content">
    <app-ndvi-chart
      [data]="data.data"
      [plotId]="data.id"
      [plotName]="data.cultura ?? ''"
    >
    </app-ndvi-chart>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <div class="dialog-info">
      <mat-icon>info</mat-icon>
      <span>Passe o cursor sobre a linha para ver os detalhes dos pontos</span>
    </div>

    <button mat-flat-button (click)="onClose()" class="apply-btn">
      <mat-icon>close</mat-icon>
      Fechar
    </button>
  </div>
</div>
